module.exports = {
  legal_reconfirmation: {
    decline: 'Ablehnen',
    tos_title: 'Aktualisierte Nutzungsbedingungen',
    privacy_title: 'Aktualisierte Datenschutzerklärung',
    tos_description: 'Die Nutzungsbedingungen dieser Plattform wurden aktualisiert. Um den Dienst weiter zu nutzen, bestätige bitte, dass du die aktuellen Bedingungen gelesen hast und ihnen zustimmst.',
    privacy_description: 'Die Datenschutzerklärung dieser Plattform wurde aktualisiert. Um den Dienst weiter zu nutzen, bestätige bitte, dass du die aktuellen Bedingungen gelesen hast und ihnen zustimmst.',
  },
  tos: {
    accept: 'Nutzungsbedingungen akzeptieren',
    title: 'Nutzungsbedingungen',
  },
  privacy_policy: {
    accept: 'Datenschutzerklärung akzeptieren',
    title: 'Datenschutzerklärung',
  },
  profile: {
    invalid_avatar: 'Dieses Bild ist ungültig',
    slug: 'App-ID',
    warning: 'Achtung',
    avatar_saving: 'Avatar wird gespeichert...',
    existing_avatars: 'Standard Avatare',
    certificates: 'Zertifikate',
    max_file_size: 'Das Bild darf maximal %{size} groß sein.',
    upload_new_avatar: 'Neues Profilbild hochladen',
    warning_description: 'Sobald du dich ausloggst, gehen all deine Daten verloren. Lege jetzt einen Account an um deine Quiz-Battles nicht zu verpassen, deinen Fortschritt zu speichern und an Gewinnspielen und Challenges teilzunehmen.',
    change_avatar: 'Profilbild ändern',
  },
  activate: {
    activate_your_account: 'Aktiviere deinen Account',
    activation_successful: 'Du hast deinen Account erfolgreich aktiviert!',
    go_to_home: 'Weiter zur Startseite',
    didnt_receive_mail_description: 'Sieh bitte auch in deinem Spam Ordner nach. Wende dich an %{adminEmail} falls es weiterhin nicht klappen sollte.',
    didnt_receive_mail: 'Du hast die E-Mail nicht erhalten?',
    mail_sent_info: 'Wir haben dir eine E-Mail an %{email} gesendet. Bitte klicke auf den Link in der Email um deinen Account zu aktivieren.',
  },
  convert: {
    description: 'Hier kannst du deinen temporären Account in einen normalen Account umwandeln.<br>Dadurch kannst du auch auf anderen Geräten spielen.',
    benefits_title: 'Die Vorteile eines Accounts:',
    title: 'Account umwandeln',
    button_convert: 'Konvertieren!',
    create_full_account: 'Jetzt Account anlegen',
    request_failed: 'Dein Account konnte leider nicht umgewandelt werden',
    benefits3: 'E-Mail Benachrichtigung zu News, neuen Dateien oder Quiz-Battles Herausforderungen',
    benefits2: 'Lernstatistiken dauerhaft speichern',
    benefits1: 'Nutzung auf mehreren Geräten: logge dich überall mit denselben Benutzerdaten ein und führe deine Lernreise einfach weiter',
  },
  signup: {
    abort: 'Registrierung abbrechen',
    password_description: 'Mindestens 8 Zeichen, Groß- und Kleinschreibung, Zahlen und Symbole.',
    confirm_abort: 'Möchtest Du die Registrierung wirklich abbrechen?',
    create_account: 'Account anlegen',
    signup: 'Account erstellen',
    username_description: 'Mit deinem Benutzernamen bist Du innerhalb der App z.B. über die Quiz-Challenge auffindbar.',
    start_with_your_account: 'Leg jetzt mit deinem Lern-Account los.',
    optional: 'Optional',
    voucher_description: 'Den Code erhältst Du vom App-Anbieter. Mit ihm schaltest Du die Lerninhalte frei.',
  },
  select_app: {
    is_being_set: 'App wird konfiguriert...',
    title: 'App-ID',
    appid_label: 'App-ID',
    next_step: 'Weiter zur Anmeldeseite',
    modal_title: 'Wie finde ich meine App ID?',
    modal_explanation: 'Die App-ID ist in der Registrierungsbestätigung enthalten. Über die Webseite der App kann die App-ID zudem im Profil eingesehen werden.',
    appid_not_found: 'Wir konnten keine Anmeldeseite für die von Ihnen eingegebene App-ID finden. Bitte prüfen Sie die Schreibweise.',
    help_please: 'Ich kann meine App-ID nicht finden',
    explanation: 'Mit Ihren Anmeldedaten wurde Ihnen eine App-ID zugesendet. Bitte geben Sie diese ein um zur Anmeldeseite zu gelangen.',
  },
  temporary: {
    description: 'Wirf einen Blick auf die Inhalte ohne einen Account anzulegen.',
    guest_account: 'Gastzugang',
    notes: 'Deine Daten verfallen sobald du dich ausloggst oder der Browser Cache gelöscht wird.\n              Mit einem Account kannst du deinen Fortschritt speichern und dich über verschiedene Endgeräte einloggen.',
    notes_title: 'Hinweis zum Testen ohne Account',
    try_now: 'Jetzt testen',
    try_without_account: 'App testen ohne Account',
  },
  login: {
    forgotpassword: 'Passwort vergessen?',
    login: 'Einloggen',
    mail: 'E-Mail',
    mail_or_username: 'E-Mail / Username',
    reset_password: 'Passwort zurücksetzen',
    title: 'Anmelden',
  },
  force_password_reset: {
    title: 'Neues Passwort vergeben',
    info: 'Mindestens 8 Zeichen, Groß- und Kleinschreibung, Zahlen und Symbole.',
    send: 'Speichern',
    explanation: 'Bitte vergib ein neues Passwort, mit welchem Du Dich künftig einloggen kannst.',
  },
  openid: {
    generic_login_error: 'Anmeldung über OpenID Connect fehlgeschlagen.',
    use_default_login: 'Standard-Login',
    no_sso_question: 'Kein Single-Sign-on?',
    please_wait: 'Bitte habe einen Moment Geduld, wir loggen dich ein...',
  },
  complete: {
    complete_successful: 'Du hast einen vollständigen Account und kannst nun auf alle Funktionen zugreifen!',
    complete_now: 'Account vervollständigen',
    request_failed: 'Dein Account konnte leider nicht aktualisiert werden',
  },
  certificates: {
    searchCertificates: 'Zertifikate durchsuchen..',
    downloadCertificate: 'Zertifikat herunterladen',
    toCourses: 'Zu den Kursen',
    youHaveNoCertificates: 'Du hast noch keine Zertifikate erhalten. Starte jetzt einen Kurs!',
  },
  delete_account: {
    confirm_deletion: 'Löschung beantragen',
    success: 'Deine Anfrage wurde gesendet',
    content: 'Möchtest du beantragen, dass dein Account gelöscht wird?',
    request_failed: 'Die Anfrage konnte leider nicht abgesendet werden. Bitte wende dich direkt an deinen Administrator.',
    title: 'Accountlöschung beantragen',
    request_account_deletion: 'Accountlöschung beantragen',
  },
  temporary_account: 'Temporärer Account',
  resetpassword: {
    didnt_receive_mail_description: 'Sieh bitte auch in deinem Spam Ordner nach oder fordere erneut ein neues Passwort an. Wende dich an %{adminEmail} falls es weiterhin nicht klappen sollte.',
    mail_sent: 'E-Mail für dich!',
    reset_button: 'Neues Passwort anfordern',
    mail_sent_info: 'Wir haben dir eine E-Mail mit einem neuen Passwort an %{email} gesendet.',
  },
  back_to_login: 'Zurück zum Login',
  password: {
    button_change_password: 'Passwort ändern',
    request_failed: 'Dein Passwort konnte leider nicht geändert werden',
    we_will_send_you_a_new_one: 'Kein Problem. Wir senden dir ein neues.',
    passwords_dont_match: 'Die neuen Passwörter stimmen nicht überein',
    success: 'Das Passwort wurde erfolgreich geändert.',
    previous: 'Aktuelles Passwort',
    new: 'Neues Passwort',
    new_repeat: 'Neues Passwort wiederholen',
    set_new_password: 'Neues Passwort speichern',
    fill_all_fields: 'Bitte fülle alle Felder aus',
  },
  slogan: 'Wir machen Lernen<br>einfach einfach.',
  new_username: 'Benutzername',
  words: 'Kurz. Spaßig. Mobil.',
  signup_are_you_new: 'Du bist neu hier?',
  logout: {
    message: 'Du wirst abgemeldet...',
  },
  reset_password: {
    title: 'Passwort zurücksetzen',
  },
}
